"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageExperimentCache = exports.createLocalStorageExperimentCache = void 0;
var O = __importStar(require("fp-ts/es6/Option"));
var A = __importStar(require("fp-ts/es6/Array"));
var M = __importStar(require("fp-ts/es6/Map"));
var function_1 = require("fp-ts/es6/function");
var Eq_1 = require("fp-ts/es6/Eq");
var experiments_io_1 = require("../experiments_io");
var PREFIX = 'aapn_ex_';
var getStorageList = function (storage) {
    var result = [];
    for (var index = 0; index < storage.length; index++) {
        var featureKey = storage.key(index);
        var value = storage.getItem(featureKey);
        if (featureKey && value) {
            // guaranteed but types don't say so
            result.push({ featureKey: featureKey, value: value });
        }
    }
    return result;
};
var createLocalStorageExperimentCache = function (getStorage) {
    var storage = getStorage();
    var getCurrentExperimentsMap = function () {
        return (0, function_1.pipe)(getStorageList(storage), A.filter(function (e) { return e.featureKey.startsWith(PREFIX); }), A.filterMap(function (e) {
            return (0, function_1.pipe)(O.tryCatch(function () { return JSON.parse(e.value); }), O.chain(function (o) { return O.fromEither(experiments_io_1.ExperimentCacheEntry.decode(o)); }));
        }), A.map(function (e) { return (0, function_1.tuple)(e.featureKey + '_' + e.principal, e); }), M.fromFoldable(Eq_1.eqString, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        { concat: function (a, _b) { return a; } }, A.array));
    };
    return {
        get: function (principal, featureKey) {
            var currentExperimentsMap = getCurrentExperimentsMap();
            return (0, function_1.pipe)(O.fromNullable(currentExperimentsMap.get(featureKey + '_' + principal)), O.map(function (cachedValue) { return ({ featureKey: cachedValue.featureKey, treatment: cachedValue.treatment }); }));
        },
        put: function (principal, experiment) {
            var cacheEntry = {
                principal: principal,
                featureKey: experiment.featureKey,
                treatment: experiment.treatment,
            };
            storage.setItem(PREFIX + experiment.featureKey + '_' + principal, JSON.stringify(cacheEntry));
        },
    };
};
exports.createLocalStorageExperimentCache = createLocalStorageExperimentCache;
exports.LocalStorageExperimentCache = (0, exports.createLocalStorageExperimentCache)(function () { return window.localStorage; });
